import { TaskStatus } from '../types/task'
import './TaskStatusBadge.css'

interface TaskStatusBadgeProps {
  status: TaskStatus
  className?: string
}

export function TaskStatusBadge({ status, className = '' }: TaskStatusBadgeProps) {
  const getStatusColor = (status: TaskStatus): string => {
    switch (status) {
      case 'created':
      case 'assigned':
      case 'in-progress':
        return '#2563eb'
      case 'performed':
      case 'resolved':
      case 'completed':
        return '#16a34a'
      case 'held':
      case 'pended':
        return '#f59e0b'
      case 'denied':
        return '#dc2626'
      case 'cancelled':
        return '#6b7280'
      case 'unassigned':
        return '#9ca3af'
      default:
        return '#6b7280'
    }
  }

  const getStatusLabel = (status: TaskStatus): string => {
    return status
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  return (
    <span
      className={`task-status-badge ${className}`}
      style={{ backgroundColor: getStatusColor(status) }}
    >
      {getStatusLabel(status)}
    </span>
  )
}

